import React from "react";
import ViewCombinedErrorsButton from "./ViewCombinedErrorsButton";
import ViewCombinedErrorsDialog from "./ViewCombinedErrorsDialog";

import { PanelDialog } from "@backslashbuild/pp-ui";

export default function ViewCombinedErrors({ syncId }) {
  const [showDialog, setShowDialog] = React.useState(false);

  return (
    <>
      <ViewCombinedErrorsButton onClick={() => setShowDialog(true)} />
      <ViewCombinedErrorsDialog
        syncId={syncId}
        open={showDialog}
        onClose={() => {
          setShowDialog(false);
        }}
      />
    </>
  );
}
